import Assign from './Assign/Assign';
import Append from './Append/Append';
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, variableRender, disabled) {
    if (action.actionName === types.ASSIGN)
        return <Assign action={action} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} />;
    if (action.actionName === types.APPEND)
        return <Append action={action} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} disabled={disabled} />;
}

export default Actions;
